import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ChargeGeofenceFormItem.module.scss';
import { Col, Row } from 'react-flexbox-grid';
import { ReactComponent as TrashIcon } from 'assets/svg/trash_no_color.svg';
import FormItem from 'common/components/formItem/FormItem';
import Label from 'common/components/label/Label';
import { SelectValueLabel } from 'common/types/SelectValueLabel';
import InputError from 'common/components/inputError/InputError';
import { Controller, UseFormMethods } from 'react-hook-form';
import Select from 'common/components/select/Select';
import InputGroup from 'common/components/inputGroup/InputGroup';
import { ChargeDto } from 'api/charges/models/ChargeDto';

type Props = {
    form: UseFormMethods<ChargeDto>;
    isDetails: boolean
    onRemoveClick: () => void;
    index: number;
    geofencesOptions: SelectValueLabel[];
} & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

const ChargeGeofenceFormItem: React.FC<Props> = ({
    form,
    isDetails,
    onRemoveClick,
    index,
    geofencesOptions,
    ...props
}: Props) => {
    const { t } = useTranslation();
    const errors = (form.errors?.geofences || [])[index] || null;
    
    const [isSmallScreen, setIsSmallScreen] = useState(
        typeof window !== 'undefined' ? window.innerWidth <= 991 : false
    );

    useEffect(() => {
        const handleResize = () => setIsSmallScreen(window.innerWidth <= 991);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return ( 
        <Row className={styles.containerRow}>
            <Col xs={!isDetails ? 10 : 12} lg={!isDetails ? 6 : 6} xl={!isDetails ? 8 : 7}>
                <FormItem>
                    {(index == 0 || isSmallScreen) && <Label className={styles.label}>{t('charges.geofences.geofence')} {!isDetails ? '*' : ''}</Label>}
                    <Controller
                        render={({ onChange, value }) => {
                            const geofencesValues = form.getValues('geofences') ?? []; // garante array
                            const selectedIds = geofencesValues.map((g: any, i: number) => (i !== index ? g.geofenceId : null)).filter(Boolean);
                            const filteredOptions = geofencesOptions.filter(x => !selectedIds.includes(x.value));
                            
                            return (
                                <Select
                                    options={filteredOptions}
                                    isClearable
                                    placeholder={t('charges.geofences.geofence')}
                                    isDisabled={isDetails}
                                    value={geofencesOptions.find(x => x.value === value) || null}
                                    onChange={(data: { value: any; }) => onChange(data?.value ?? null)}
                                />
                            );
                        }}
                        rules={{ required: true }}
                        control={form.control}
                        name={`geofences[${index}].geofenceId`}
                        defaultValue={form.getValues(`geofences[${index}].geofenceId`)} />
                    <InputError error={errors?.geofenceId} />
                </FormItem>
            </Col>
            <Col xs={!isDetails ? 10 : 12} lg={!isDetails ? 4 : 6} xl={!isDetails ? 3 : 5}>
                <FormItem>
                    {(index == 0 || isSmallScreen) && <Label className={styles.label}>{t('charges.geofences.percentage')}</Label>}
                    <Controller
                        render={({ value, onChange }) => {
                            return (
                                <InputGroup
                                    placeholder={t('charges.geofences.percentage_label')}
                                    text="%"
                                    format="number"
                                    value={value}
                                    onValueChange={onChange}
                                    disabled={isDetails} />
                            );
                        }}
                        control={form.control}
                        name={`geofences[${index}].percentage`}
                        defaultValue={form.getValues(`geofences[${index}].percentage`)}
                            rules={{
                            min: { value: Number.EPSILON, message: t('charges.geofences.min_value_greater_than_0' as any) },
                            max: { value: 100, message: t('common.errors.max_value_100') }
                        }}
                    />
                    <InputError error={errors?.percentage} />
                </FormItem>
            </Col>


            {!isDetails &&
                <Col xs={2} sm={2} lg={1}>
                    <FormItem>
                    {(index == 0 || isSmallScreen) && <Label className={styles.label}>&nbsp;</Label>}
                    <div className={styles.removeButtonContainer}>
                        <div className={styles.removeButton} onClick={onRemoveClick}>
                            <TrashIcon className={styles.removeIcon} />
                        </div>
                    </div>
                    
                    </FormItem>
                </Col>
            }
        </Row> 
    );
}

export default ChargeGeofenceFormItem;
